export const externalLinks = {
  discord: 'https://discord.gg/eBQhDdjZpB',
  facebook: 'https://www.facebook.com/seasideclubofficial',
  instagram: 'https://www.instagram.com/seasideclubofficial',
  twitter: 'https://twitter.com/seaside_investm?s=11&t=dBRfYRFir6Dv3j3al7vMWw',
  youtube: 'https://www.youtube.com/channel/UCQTAtMZ-Lk79KmIB-DvqA-w',
  medium: 'https://medium.com/@Seaside_Club',
};
